import axios from "axios";
import { projectid } from "../../common/redux/ApiClient";

const baseUrl = process.env.REACT_APP_BASE_DOMAIN;;
const domain = process.env.REACT_APP_API_DOMAIN;

export const LOGIN_URL = `${baseUrl}/login`;

export const getCurrentCountryCode = (ipAddress) => {
  return axios
    .get(`https://ipapi.co/${ipAddress}/json/`, {})
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else {
        return error;
      }
    });
};

export const login = (queryParams) => {
  return axios
    .post(`${window.location.protocol}//${domain}/index.php`, {
      url: `${baseUrl}/${process.env.REACT_APP_PROJECT_ID === "mm6mm" ? "MobileA1" : "Member1"}.ashx`,
      data: { ...queryParams, projectid },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else {
        return error;
      }
    });
};
export const loginChoose = (queryParams) => {
  return axios
    .post(`${window.location.protocol}//${domain}/index.php`, {
      url: `${baseUrl}/Member5.ashx`,
      data: { ...queryParams, projectid },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else {
        return error;
      }
    });
};

export const addLoginAcc = (queryParams) => {
  return axios
    .post(`${window.location.protocol}//${domain}/index.php`, {
      url: `${baseUrl}/Member5.ashx`,
      data: { ...queryParams, projectid },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else {
        return error;
      }
    });
};

export const fetchIPAddress = () => {
  return axios
    .get(`${window.location.protocol}//${domain}/clientIP.php`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else {
        return error;
      }
    });
};

export const fetchVerificationCode = () => {
  return axios
    .post(`${window.location.protocol}//${domain}/index.php`, {
      url: `${baseUrl}/System1.ashx`,
      data: {
        action: "vefiticationCodeImage",
        projectid: projectid,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else {
        return error;
      }
    });
};

export const fetchLoginPage = (seldemocompany = "") => {
  return axios
    .post(`${window.location.protocol}//${domain}/index.php`, {
      url: `${baseUrl}/Mobile2.ashx`,
      data: {
        action: "mbloginpageV3",
        projectid: projectid,
        resetkey: "",
        seldemocompany,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else {
        return error;
      }
    });
};

export const fetchDemoCompanyGame = (seldemocompany = "") => {
  return axios
    .post(`${window.location.protocol}//${domain}/index.php`, {
      url: `${baseUrl}/Mobile2.ashx`,
      data: {
        action: "democompanygame",
        projectid: projectid,
        resetkey: "",
        seldemocompany,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else {
        return error;
      }
    });
};

export const getOTP = (queryParams) => {
  return axios
    .post(`${window.location.protocol}//${domain}/index.php`, {
      url: `${baseUrl}/Member1/PhoneRegisterOtp`,
      data: queryParams,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else {
        return error;
      }
    });
};

export const fetchLogoBackground = (queryParams) => {
  return axios
    .post(`${window.location.protocol}//${domain}/index.php`, {
      url: `${baseUrl}/MemberMobile1/MbLoginRegisterPageUI`,
      data: queryParams,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else {
        return error;
      }
    });
};
export const fetchCurrencyList = (queryParams) => {
  return axios
    .post(`${window.location.protocol}//${domain}/index.php`, {
      url: `${baseUrl}/Member1/CurrencyList`,
      data: queryParams,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else {
        return error;
      }
    });
};

//start : register

export const register = (queryParams) => {
  return axios
    .post(`${window.location.protocol}//${domain}/index.php`, {
      url: `${baseUrl}/Member7.ashx`,
      data: { ...queryParams, projectid, action: "memberregistersms_step1" },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else {
        return error;
      }
    });
};

export const registerStep2 = (queryParams) => {
  return axios
    .post(`${window.location.protocol}//${domain}/index.php`, {
      url: `${baseUrl}/Member7.ashx`,
      data: { ...queryParams, projectid, action: "memberregistersms_step2" },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else {
        return error;
      }
    });
};

export const registerStep3 = (queryParams) => {
  return axios
    .post(`${window.location.protocol}//${domain}/index.php`, {
      url: `${baseUrl}/Member1/PhoneRegisterFinal`,
      data: queryParams,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else {
        return error;
      }
    });
};

//end : register

//start : phone authentication

export const phoneAuthStep1 = (queryParams) => {
  return axios
    .post(`${window.location.protocol}//${domain}/index.php`, {
      url: `${baseUrl}/Member1/MemberPhoneRequestOtp`,
      data: queryParams,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else {
        return error;
      }
    });
};

export const phoneAuthStep2 = (queryParams) => {
  return axios
    .post(`${window.location.protocol}//${domain}/index.php`, {
      url: `${baseUrl}/Member1/MemberIDVerifyEnterOtp`,
      data: queryParams,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else {
        return error;
      }
    });
};

//end : phone authentication

//start : forgot password

export const forgotPasswordStep1 = (queryParams) => {
  return axios
    .post(`${window.location.protocol}//${domain}/index.php`, {
      url: `${baseUrl}/Member7.ashx`,
      data: {
        ...queryParams,
        action: "forgetusernamepassword_step1",
        projectid: projectid,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else {
        return error;
      }
    });
};

export const forgotPasswordStep2 = (queryParams) => {
  return axios
    .post(`${window.location.protocol}//${domain}/index.php`, {
      url: `${baseUrl}/Member7.ashx`,
      data: {
        ...queryParams,
        action: "forgetusernamepassword_step2",
        projectid: projectid,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else {
        return error;
      }
    });
};

export const forgotPasswordStep3 = (queryParams) => {
  return axios
    .post(`${window.location.protocol}//${domain}/index.php`, {
      url: `${baseUrl}/Member1/ResetPasswordOtpPhone`,
      data: queryParams,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else {
        return error;
      }
    });
};

//end : forgot password
//start : gmailforgot password

export const gmailForgotPasswordStep1 = (queryParams) => {
  return axios
    .post(`${window.location.protocol}//${domain}/index.php`, {
      url: `${baseUrl}/Member2/ForgetPasswordEmail`,
      data: queryParams,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else {
        return error;
      }
    });
};

export const gmailForgotPasswordStep2 = (queryParams) => {
  return axios
    .post(`${window.location.protocol}//${domain}/index.php`, {
      url: `${baseUrl}/Member2/ForgetPasswordEmailCheckOtp`,
      data: queryParams,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else {
        return error;
      }
    });
};

export const gmailForgotPasswordStep3 = (queryParams) => {
  return axios
    .post(`${window.location.protocol}//${domain}/index.php`, {
      url: `${baseUrl}/Member2/ResetPasswordOtpEmail`,
      data: queryParams,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else {
        return error;
      }
    });
};

//end : gmail forgot password
//start : google authentication

export const googleRegister = (queryParams) => {
  return axios
    .post(`${window.location.protocol}//${domain}/index.php`, {
      url: `${baseUrl}/Member2/SocialMediaRegister`,
      data: queryParams,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else {
        return error;
      }
    });
};

export const googleLogin = (queryParams) => {
  return axios
    .post(`${window.location.protocol}//${domain}/index.php`, {
      url: `${baseUrl}/Member2/SocialMediaLogin`,
      data: queryParams,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else {
        return error;
      }
    });
};

//end : google authentication

export const fetchLoginSlide = (language) => {
  return axios
    .post(`${window.location.protocol}//${domain}/index.php`, {
      url: `${baseUrl}/MemberPc1/PcLoginRegisterPageUI`,
      data: { language },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else {
        return error;
      }
    });
};
export const fetchPromoUrl = (queryParams) => {
  return axios
    .post(`${window.location.protocol}//${domain}/getApi.php`, {
      url: `${baseUrl}/Member8/PromoDialogUrl?${queryParams}`,
      data: {},
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else {
        return error;
      }
    });
};
export const getUserData = () => {
  const data = localStorage.getItem("UserData");
  if (!data) {
    return;
  }

  try {
    const auth = JSON.parse(data);
    if (auth) {
      // You can easily check auth_token expiration also
      return auth;
    }
  } catch (error) {
    console.error("AUTH LOCAL STORAGE PARSE ERROR", error);
  }
};
